{
    "Section_Header": "Options d'envoi :",
    "Section_SubHeader": "Envoyer les rapports à :",
    "Validation_Valid_Domain_Name": "L'adresse e-mail doit être valide.",
    "Validation_Valid_Same_As_User": "L'adresse e-mail doit appartenir au même domaine que l'utilisateur actuel.",
    "Validation_Valid_Non_Blacklisted_Email": "L'adresse électronique ne doit pas provenir d'un domaine figurant sur une liste noire.",
    "Validation_Valid_Max_Custom_Domains": "Vous ne pouvez ajouter qu'un maximum de {} adresses e-mail personnalisées.",
    "Validation_Valid_Max_Entries": "Vous ne pouvez pas avoir plus de {} adresses e-mail",
    "NAME": "ReportSchedulingEmails"
}